import React from 'react';
import Map from 'google-map-react';
import PropTypes from "prop-types";

const MarkerPrimary = ({ text }) => <span className="material-icons tw-text-orange-400 tw-text-3xl">circle</span>;
const MarkerSecondary = ({ text }) => <span className="material-icons tw-text-gray-600">circle</span>;

class GoogleMap extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            center: {
                lat: this.props.lat,
                lng: this.props.lng
            },
        };
    }

    render() {

        const {
            address, lat, lng
        } = this.props;

        const {
            center
        } = this.state

        let mapStyle =
            [
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.land_parcel",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "stylers": [
                        {
                            "color": "#e8e8e8"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "stylers": [
                        {
                            "color": "#81c7fd"
                        }
                    ]
                }
            ]
        return (
            <section id={'map'} className="tw-bg-gray-700 h-half">
                <div className="tw-w-full tw-h-full tw-relative">
                    <Map
                        bootstrapURLKeys={{key: this.props.apiKey}}
                        defaultCenter={center}
                        defaultZoom={this.props.zoom}
                        options={{ styles: mapStyle }}
                    >
                        {/*<MarkerSecondary
                            lat={21.035122}
                            lng={-86.789078}
                        />*/}
                        <MarkerPrimary
                            lat={lat}
                            lng={lng}
                        />
                    </Map>

                    {
                        (address !== '' && address !== null) &&
                        <div className="map-address tw-absolute tw-left-0 tw-bottom-0 tw-w-full tw-p-4 tw-hidden md:tw-inline">
                            <h4 className="tw-font-normal font-arapey tw-text-gray-700 tw-text-2xl tw-bg-white tw-w-full lg:tw-w-1/2 tw-p-4">
                                {address}
                            </h4>
                        </div>
                    }

                </div>
            </section>
        );
    }
}

GoogleMap.defaultProps = {
    zoom: 12,
    apiKey: 'AIzaSyDJCcspn8tohBRqruQ7AR5xRaaIIY4d9Ug'
}

GoogleMap.propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    address: PropTypes.string
};

export default GoogleMap;
